<template>
    <div class="donate-container">
		<div class="title-box">
            <h5>민팃과 <b>{{donateItem.cstmNm}}</b>님이 함께하는</h5>
            <div class="numberContainer">
                <div class="numberBox">
                    <div class="numberText">
                        <span style="margin-top: 0px;">{{donateItem.dntnCntFirst}}</span>
                    </div>
                    <div class="numberText">
                        <span style="margin-top: 0px;">{{donateItem.dntnCntSecond}}</span>
                    </div>
                    <p>번째 기부</p>
                </div>
            </div>
        </div>
        <div class="donate-box">
            <div>
                <img src="@/assets/images/donate-box-bg.png" alt="" width="100%" style="vertical-align: bottom;">
                <p><b>
                    {{numberFormatByComma(Number(donateItem.partDntnAmt))}}
                </b>원</p>
            </div>
            <span>{{donateItem.prchRegDt}} 판매액 기부</span>
        </div>
        <div class="desc-box">
            <p>따뜻한 나눔을 실천해주셔서 감사합니다</p>
            <span>중고폰 재활용/환경 보호 활동에 기여하고, <br/>소중한 기부금은 IT분야의 꿈나무를 후원하는데 <br/>사용하겠습니다.</span>
        </div>
        <div class="donate-phone-box">
            <div class="phone-box">
                <h6 style="font-size: 11px;">기부 프로젝트에 동참한 휴대폰</h6>
            </div>
            <p><b>{{numberFormatByComma(Number(donateItem.totalDntnCnt))}}</b>대</p>
            <span>{{donateItem.totalDntnMonth}} 기준</span>
        </div>
		<div class="collabor-box">
			<img src="@/assets/images/donate-collabor-logo.png" alt="콜라보 로고" width="355">
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'

export default {
  name: 'DonateDetailData',
  components: {
  },
  data: () => ({
    AppConfig: AppConfig,
    donateItem: {
        cstmNm: '',
        dntnCntFirst: '',
        dntnCntSecond: '',
        partDntnAmt:0,
        prchRegDt:'',
        totalDntnMonth:'',
        totalDntnMonth:'',
        totalDntnCnt:''
      }
  }),
  computed: {
    getOrderNumber () {
      return this.$route.query.ordNum
    }
  },
  mounted() {
    this.getDonateInfo()
  },
  methods: {
    async getDonateInfo () {
      const res = await this.$http.get(`/api/purchase/public/donate/getDonateInfo/${this.getOrderNumber}`)
      if (res) {
        const { data: { status, result } } = res
        if (status === '200' && result) {
            this.donateItem = result
            if (result.dntnCnt < 10) {
                this.donateItem.dntnCntFirst = '0'
                this.donateItem.dntnCntSecond = result.dntnCnt
            } else if (result.dntnCnt > 99) {
                this.donateItem.dntnCntFirst = '9'
                this.donateItem.dntnCntSecond = '9'
            } else {
                this.donateItem.dntnCntFirst = result.dntnCnt.substr(0, 1)
                this.donateItem.dntnCntSecond = result.dntnCnt.substr(1, 2)
            }
        } else {
          this.$Alert.alert('기부 정보를 확인하지 못했습니다. 잠시 후 다시 시도해 주시기 바랍니다.')
        }
      }
    },
    numberFormatByComma (val) {
      const removeDecimalPointVal = String(Math.floor(val || 0))
      // return removeDecimalPointVal.replace(/[^0-9]/g, "") || "0";
      return removeDecimalPointVal.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/purchase/DonateDetailData.vue